{
    "ReporttypeDesktopwallboard": "Wallboard per desktop (senza licenza)",
    "ReporttypeDashboard": "Cruscotto",
    "ReporttypeActivecalllist": "Elenco chiamate attive (senza licenza)",
    "ReporttypeHistoriccalllist": "Elenco storico delle chiamate",
    "ReporttypeUnreturnedlostcalls": "Chiamate perse senza risposta (senza licenza)",
    "ReporttypeExtensionlist": "Elenco delle estensioni (senza licenza)",
    "ReporttypeAcdagentlist": "Elenco agenti ACD (senza licenza)",
    "ReporttypeHuntgrouplist": "Elenco gruppi di caccia (senza licenza)",
    "ReporttypeTrunkinterfacelist": "Elenco delle interfacce di trunk",
    "ReporttypeCallsbytelno": "Chiamate per numero di telefono",
    "ReporttypeCallsbyddi": "Chiamate da DDI (senza licenza)",
    "ReporttypeCallsbyhalfhourinterval": "Chiamate per intervallo di ½ ora",
    "ReporttypeCallsbyhalfhourplusday": "Chiamate per ½ ora + giorno",
    "ReporttypeCallsbyday": "Chiamate di giorno",
    "ReporttypeCallsbyweek": "Chiamate per settimana",
    "ReporttypeCallsbymonth": "Chiamate per mese",
    "ReporttypeCallsbyaccountcode": "Chiamate per codice conto (senza licenza)",
    "ReporttypeAcddndactivitylog": "Registro attività ACD\/DND (senza licenza)",
    "ReporttypeAcsnacodeusage": "Uso del codice ACS N\/A (senza licenza)",
    "ReporttypeExternalcontent": "Contenuto esterno (tramite URL)",
    "ReporttypeUnlicensedformattingstring": "|1 (senza licenza)",
    "GroupLive": "Eventi dal vivo",
    "GroupEntity": "Entità",
    "GroupLogs": "Registri",
    "GroupInterval": "Intervallo",
    "GroupMisc": "Varie",
    "NAME": "ReportTypes"
}